import React, { useCallback, useContext, useState } from "react";
import { USERTYPES, REPORT_DONE_STATUS } from "../../../../constants/Constants";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import userContext from "../../../../context/users/UserContext";
import '../../styles/styles.css';
import DropdownSection from "./DropdownSection";
import TemplateCategory from "./TemplateCategory";
import S10Icon from "../../../../components/SVGComponents/S10Icon";
import ModalMain from "../../../../components/Modal/ModalMain";
import ModalHeader from "../../../../components/Modal/ModalHeader";
import ModalFooter from "../../../../components/Modal/ModalFooter";
import { t } from "i18next";
import themeContext from "../../../../context/theme/ThemeContext";
import { AddIcon, DeleteIcon } from "@fluentui/react-icons-mdl2";
import RowBadge from "../../../StudyList/components/Badge/RowBadge";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import EyeIcon from "../../../../components/SVGComponents/EyeIcon";
import loaderContext from "../../../../context/loader/LoaderContext";

const RadioDropdownSection = () => {

    const { roles, username, authenticated, loadByUsername, userId } = useContext(userContext);
    const { getThemeColor } = useContext(themeContext);
    const { s10User, s10Url, studyReportPdf, studyReportPdfUrl, handleAttachToggle, reportingDoctorName } = useContext(studyReportContext);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const { ref, setLoaderRunning, setShowModal, showModal } =
        useContext(loaderContext);

    const togglePopup = useCallback(() => {
        setIsPopupOpen(prevState => !prevState);
    }, []);

    let DefaultButtonList = [
        {
            title: "Close",
            onclick: togglePopup,
        },
    ];

    const modalDetails = {
        header: (
            <ModalHeader
                updatedModal={true}
                heading="S10.ai"
                handleCancel={togglePopup}
            />
        ),
        body: <div className="global-modal-body" style={{ color: getThemeColor("primary-color"), padding:"0px" }}>
            <iframe
                id="s10Iframe"
                src={s10Url}
                style={{
                    //width: '100%',
                    height: '525px',
                    border: 'none',
                    background: 'transparent',
                }}
                allow='web-share;clipboard-write;autoplay;camera;microphone;display-capture'
            />
        </div>,
        footer: <ModalFooter PrimaryButtonList={[]} DefaultButtonList={DefaultButtonList} />,
        width: "380px"
    };

    const handleOpenPdfInNewTab = () => {
        // if (!studyReportPdfUrl) return;
    setLoaderRunning(true);
    ref.current.continuousStart();
        window.open(
            studyReportPdfUrl,
            "_blank",
            "noopener,noreferrer"
        );

        setLoaderRunning(false);
        ref.current.complete();
    };

    return (
      <>
        <div
          className="ms-Grid "
          dir="ltr"
          style={{
            margin: "0px",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "100%",
          }}
        >
          {<TemplateCategory />}

          {s10User && (
            <div style={{ marginLeft: "auto" }}>
              <span
                style={{
                  cursor: "pointer",
                  padding: "7px 12px",
                  borderRadius: "8px",
                  backgroundColor: "#003a5f",
                  display: "flex",
                }}
                onClick={togglePopup}
              >
                <S10Icon />
              </span>
            </div>
          )}

          {studyReportPdf && (
            <div
              style={{
                marginLeft: "auto",
                display: "flex",
                alignItems: "center",
              }}
            >
              <span style={{marginRight: "10px",}}>
                <RowBadge tooltipText="AI Report" name="AI Report" colorObj={{ background: '#E91E63', color: '#FFFFFF' }}/>{" "}
              </span>
              <CustomToolTipHost content={t("button.preview")}>
                <span
                  onClick={handleOpenPdfInNewTab}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "10px",
                    cursor: "pointer",
                    color: getThemeColor("primary-color"),
                  }}
                >
                  <EyeIcon />
                </span>
              </CustomToolTipHost>
              {roles[0] == USERTYPES.RADIOLOGIST && reportingDoctorName && username == reportingDoctorName && (
                <CustomToolTipHost content={studyReportPdf.isAttached ? "Remove" : "Attach"}>
                  <span
                    onClick={handleAttachToggle.bind(
                      this,
                      !studyReportPdf.isAttached,
                    )}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "10px",
                      cursor: "pointer",
                      color: getThemeColor("primary-color"),
                    }}
                  >
                    {studyReportPdf.isAttached ? <DeleteIcon /> : <AddIcon />}
                  </span>
                </CustomToolTipHost>
              )}
            </div>
          )}
        </div>

        {isPopupOpen && (
          <ModalMain
            updatedModal={true}
            modalDetails={modalDetails}
            showModal={true}
          />
        )}
      </>
    );
};

export default RadioDropdownSection;